import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const STATEMENTS_OF_WORK_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('STATEMENTS_OF_WORK');
export const STATEMENTS_OF_WORK_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	STATEMENTS_OF_WORK_CRUD_ACTION_CONSTANTS
);
